import { Outlet } from "react-router-dom";
import { TeamProvider } from "../context/TeamContext";

export function TeamProviderWrapper() {
  return (
    <TeamProvider>
      <Outlet />
    </TeamProvider>
  );
}